const HeroNotificationBar = () => {
  // const showBar = localStorage.getItem('showBar');
  const NotificationBarHTML = $('.notification-bar--hero');

  // if(showBar === 'false'){
  //     $(NotificationBarHTML).hide();
  // }

  const closeTrigger = $('.notification-bar--hero .notification-bar__close');
  closeTrigger.on('click', function () {
    $(NotificationBarHTML).hide();
    // localStorage.setItem('showBar', 'false');
  });
};

export default HeroNotificationBar;
